import React, { useState, useEffect } from 'react';

const BgAnimation = () => {
  return (
    <div className="area">
      <div className="circles">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};
export default BgAnimation;
